import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createNumberedCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers/numberedCardBlockHelper";
import {
  createButtonBlock,
  createH2Block,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getSalesBlockSecondaryStyleOptions } from "../constants";

const cards = [
  {
    number: "1",
    title: "Apply",
    description:
      "Complete a brief application to ensure we're the right fit for each other.",
  },
  {
    number: "2",
    title: "Strategy Call",
    description:
      "We'll discuss your goals and create a personalized coaching plan.",
  },
  {
    number: "3",
    title: "Begin Your Growth",
    description:
      "Start your 12 week transformation with full support and guidance.",
  },
  {
    number: "4",
    title: "Achieve Results",
    description:
      "Implement your new skills and mindset to create lasting change.",
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "SalesBlock5",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "How The Program Works",
        }),
      ],
    },
    cards: {
      prop: "children",
      type: "children",
      value: cards.map(card => createNumberedCardBlock(card)),
    },
    footer: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Start Your Journey Today",
          href: "#",
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getSalesBlockSecondaryStyleOptions(),
      },
    },
  },
};
